/**
 * Podpisy elektroniczne: pisane (imię i nazwisko w czcionce odręcznej)
 * albo obrazkowe (starsze wnioski — data URL PNG/JPEG).
 */

const OBRAZEK_REGEX = /^data:image\/(png|jpeg);base64,[A-Za-z0-9+/]+={0,2}$/;

export const CZCIONKA_PODPISU = "'Caveat', cursive";

export function jestPodpisObrazkowy(value) {
  return typeof value === 'string' && value.startsWith('data:image/');
}

/** Bezpieczny obraz podpisu do atrybutu src — tylko poprawny data URL PNG/JPEG, inaczej pusty string */
export function bezpiecznyObrazPodpisu(value) {
  return jestPodpisObrazkowy(value) && OBRAZEK_REGEX.test(value) ? value : '';
}

export function escapeHtml(s) {
  return String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Podpis jako fragment HTML (do wydruków i PDF generowanych z tekstu HTML).
 * Zawsze escapowany — podpis pochodzi od użytkownika.
 */
export function podpisHtml(value, { maxWidth = 180, maxHeight = 60, fontSize = 26, align = 'center' } = {}) {
  if (!value) return '';
  if (jestPodpisObrazkowy(value)) {
    const src = bezpiecznyObrazPodpisu(value);
    if (!src) return '';
    const margin = align === 'center' ? 'margin:0 auto;' : align === 'right' ? 'margin-left:auto;' : '';
    return `<img src="${src}" alt="Podpis" style="max-width:${maxWidth}px;max-height:${maxHeight}px;display:block;${margin}" />`;
  }
  return `<span style="font-family:${CZCIONKA_PODPISU};font-size:${fontSize}px;line-height:1.1;display:inline-block;color:#1a1a1a;">${escapeHtml(value)}</span>`;
}

/** Link do czcionki podpisu — dla okien wydruku otwieranych przez window.open */
export const LINK_CZCIONKI_PODPISU =
  '<link href="https://fonts.googleapis.com/css2?family=Caveat:wght@500;600&display=swap" rel="stylesheet">';
